import { counterInitialState, reducer as counter } from "./counter";
import { availableCEInitialState, reducer as availableCE } from "./availableCE";
import { claimedCEInitialState, reducer as claimedCE } from "./claimedCE";
import { settingsInitialState, reducer as settings } from "./settings";
import { userInfoInitialState, reducer as userInfo } from "./userInfo";
import { toastInitialState, reducer as toast } from "./toast";
import {
  contentConfigInitialState,
  reducer as contentConfig,
} from "./contentConfig";
import {
  questionnaireInitialState,
  reducer as questionnaire,
} from "./questionnaire";
import { homeWidgetInitialState, reducer as homeWidget } from "./ceHomeWidget";
import { cmeButtonInitialState, reducer as cmeButton } from "./ceCmeButton";

export const initialState = {
  counter: counterInitialState,
  availableCE: availableCEInitialState,
  claimedCE: claimedCEInitialState,
  settings: settingsInitialState,
  contentConfig: contentConfigInitialState,
  questionnaire: questionnaireInitialState,
  userInfo: userInfoInitialState,
  toast: toastInitialState,
  homeWidget: homeWidgetInitialState,
  cmeButton: cmeButtonInitialState,
};

const reducers = {
  counter,
  availableCE,
  claimedCE,
  settings,
  contentConfig,
  questionnaire,
  userInfo,
  toast,
  homeWidget,
  cmeButton,
};

export const combineReducers = (reducersObj) => {
  return (state, action) => {
    return Object.keys(reducersObj).reduce((nextState, key) => {
      nextState[key] = reducersObj[key](state[key], action);
      return nextState;
    }, {});
  };
};

export const reducer = combineReducers(reducers);
